import { render } from "./Sketch.vue?vue&type=template&id=5a577154"
import script from "./Sketch.vue?vue&type=script&lang=js"
export * from "./Sketch.vue?vue&type=script&lang=js"

import "./Sketch.vue?vue&type=style&index=0&id=5a577154&lang=css"

import exportComponent from "/home/mathias/PhpstormProjects/clone/vue3-color/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__